import { render, staticRenderFns } from "./ListNotifications.vue?vue&type=template&id=3f8d0155&scoped=true&"
import script from "./ListNotifications.vue?vue&type=script&lang=js&"
export * from "./ListNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ListNotifications.vue?vue&type=style&index=0&id=3f8d0155&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8d0155",
  null
  
)

export default component.exports